<template>
  <section
    id="logos"
    class="padding-y-5xl inverted"
    style="background-color: var(--fa-dk-navy)"
  >
    <div class="container text-center">
      <h2
        class="text-uppercase size-md"
        style="letter-spacing: var(--letter-spacing-3xl); font-weight: var(--font-weight-black); color: var(--fa-yellow)"
      >
        The Web's Default Icon Set, Used on Over 200 Million Sites
      </h2>
      <div class="display-flex align-middle align-center align-around flex-wrap size-lg laptop:size-xl">
        <div
          v-for="[url, icon, title, size] in iconGroup"
          :key="title"
          class="margin-top-xl"
        >
          <a
            :href="url"
            class="padding-x-sm"
            style="--link-color: var(--white); --link-hover-color: var(--fa-blue)"
            target="_blank"
            rel="nofollow"
            @click="$posthog.capture('home:logo_link_click', { logo: title })"
          >
            <font-awesome-icon
              :icon="icon"
              :title="title"
              :size="size"
            />
          </a>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import sampleSize from 'lodash/sampleSize'

  // How many brands to get
  const GROUP_SIZE = 5

  export default {
    name: 'Logos',

    data() {
      return {
        brands: [
          ['https://aaa.com', this.$v7.custom.faAaa, 'AAA', '4x'],
          ['https://aws.amazon.com', this.$v7.brands.faAws, 'Amazon Web Services', '3x'],
          ['https://www.docker.com', this.$v7.custom.faDocker, 'Docker', '5x'],
          ['https://dndbeyond.com', this.$v7.custom.faDungeonsDragons, 'Dungeons & Dragons', '4x'],
          ['https://www.figma.com', this.$v7.brands.faFigma, 'Figma', '2x'],
          ['https://goldbelly.com', this.$v7.custom.faGoldbelly, 'Goldbelly', '3x'],
          ['https://www.hover.com', this.$v7.custom.faHover, 'Hover', '4x'],
          ['https://ifixit.com', this.$v7.custom.faIfixit, 'iFixit', '4x'],
          ['https://un.org', this.$v7.custom.faUnitedNations, 'United Nations', '6x']
        ]
      }
    },

    computed: {
      iconGroup() {
        return sampleSize(this.brands, GROUP_SIZE)
      }
    }
  }
</script>
